import Vue from 'vue';
import FolderService from './folder.service';

const getDefaultItem = () => ({
    id: null,
    folderName: null,
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
});

const folder = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        clear(state) {
            Vue.set(state, 'item', JSON.parse(JSON.stringify(getDefaultState().item)));
            Vue.set(state, 'list', JSON.parse(JSON.stringify(getDefaultState().list)));
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        async queryRoot(context) {
            const { data } = await FolderService.queryRoot();
            context.commit('updateList', data);
            return data;
        },
        async queryByParentFolder(context, client_data) {
            const { parentFolderId } = client_data;
            const { data } = await FolderService.queryByParentFolder(parentFolderId);
            context.commit('updateList', data);
            return data;
        },
        async createFolder(context, client_data) {
            const { parentFolderId, folderName } = client_data;
            const { data } = await FolderService.create(parentFolderId, folderName);
            context.commit('updateList', data);
            return data;
        },
        async updateFolder(context, client_data) {
            const { folder } = client_data;
            const { data } = await FolderService.update(folder);
            return data;
        },
    },

    getters: {
        list(state) {
            return state.list;
        },
    },
};

export default folder;
